// extracted by mini-css-extract-plugin
module.exports = {"mark":"Marker_mark__AS8IQ","markerLabel":"Marker_markerLabel__3ifmL"};